module.exports = __webpack_public_path__ + "static/img/TW.5288ee42.svg";